<template>
  <v-container>
    <CompanyApprenticeList />
  </v-container>
</template>

<script>
import CompanyApprenticeList from '@/components/Company/CompanyApprenticeList'
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'

export default {
  name: 'CompanyEmployees',

  components: {
    CompanyApprenticeList,
    CompanyEmployeeList
  }
}
</script>

<style lang="scss">
</style>